/* ============================================================
   Kaynaturalz — interactions (Shopify build)
   Same rendering + behaviour as the Claude Design preview, with
   the demo cart replaced by the real Shopify AJAX Cart API.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- DATA (matches the design + live catalog) ---------- */
  var CDN = "https://cdn.shopify.com/s/files/1/0411/3262/1976/files/";
  var PRODUCTS = [
    { title: "Organic Turmeric Soap Bar", desc: "Brightening goat-milk cleansing bar for dark marks & uneven tone — now 5 oz", price: 14.99, compareAt: 23.0, rating: 4.9, img: CDN + "kn-tum-front.png?v=1784835388", url: "/products/organic-turmeric-soap-bar", variantId: 44831452299478, badges: [["New · 5 oz","brick"],["Best Seller","gold"]] },
    { title: "Glow Oil", desc: "Moisture-locking glow oil for scars, dry patches & radiance", price: 23.0, rating: 4.9, img: CDN + "DSC01925.jpg?v=1756747606", url: "/products/glow-oil", variantId: 44831453741270, badges: [["Routine Essential","dark"]] },
    { title: "Organic Oat Soap Bar", desc: "Gentle, soothing goat-milk bar for sensitive, irritated or eczema-prone skin — now 5 oz", price: 14.99, compareAt: 23.0, rating: 4.9, img: CDN + "kn-oat-front.png?v=1784835388", url: "/products/untitled-jan2_20-48", variantId: 44831485755606, badges: [["New · 5 oz","brick"],["Sensitive Skin","dark"]] },
    { title: "Detoxifying Clay Mask", desc: "Weekly detox mask for clogged pores & dull skin", price: 15.0, rating: 4.9, img: CDN + "DSC01967.jpg?v=1755719119", url: "/products/detoxifying-clay-mask", variantId: 44838662013142, badges: [["Weekly Detox","dark"]] },
    { title: "Duo Skincare Bundle", desc: "Simple two-step routine for cleansing & glow", price: 40.0, rating: 4.9, img: CDN + "bundle-tumeric.jpg?v=1784822838", url: "/products/duo-skincare-bundle", variantId: null, badges: [["Beginner Pick","dark"]] },
    { title: "Fade & Glow Bundle", desc: "Complete routine for stubborn dark marks & full body glow", price: 70.0, rating: 4.9, img: CDN + "biggest-bundle-tumeric.jpg?v=1784824710", url: "/products/fade-glow-bundle", variantId: null, badges: [["Best Seller","gold"],["Bundle & Save","gold"]] },
    { title: "Glow Essentials Bundle", desc: "Daily glow essentials for an even, radiant complexion", price: 55.0, rating: 4.9, img: CDN + "larger-bundle.jpg?v=1784824198", url: "/products/glow-essentials-bundle", variantId: null, badges: [["Bundle & Save","gold"]] },
    { title: "Ultimate Glow Bundle", desc: "Our most complete routine for a head-to-toe glow", price: 120.0, rating: 4.9, img: CDN + "Gemini_Generated_Image_n5dvdgn5dvdgn5dv_ffe771ae-8a5e-425e-a41e-c88a09b4a5a0.png?v=1764893066", url: "/collections/inventory", variantId: null, badges: [["Bundle & Save","gold"]] }
  ];

  var ED = CDN;
  var CONCERNS = [
    { title: "Dark Marks & Hyperpigmentation", desc: "Target stubborn dark marks with a routine made for consistency.", img: ED + "DSC03881.jpg", url: "/products/organic-turmeric-soap-bar" },
    { title: "Acne Scars & Breakouts", desc: "Calm breakouts and fade the marks they leave behind.", img: ED + "DSC03925.jpg", url: "/products/organic-turmeric-soap-bar" },
    { title: "Sensitive or Eczema Prone", desc: "Gentle, soothing formulas for reactive skin.", img: ED + "DSC03982.jpg", url: "/products/untitled-jan2_20-48" },
    { title: "Dull or Uneven Tone", desc: "Bring back radiance with brightening botanicals.", img: ED + "DSC03916.jpg", url: "/products/glow-toner" },
    { title: "Face & Body Glow", desc: "A head-to-toe routine for visible, even glow.", img: ED + "DSC04036.jpg", url: "/products/fade-glow-bundle" },
    { title: "Beginner Friendly Routine", desc: "Start simple. Stay consistent. See results.", img: ED + "DSC04095.jpg", url: "/products/duo-skincare-bundle" }
  ];

  var LOOKBOOK = ["DSC03882","DSC04082","DSC03954","DSC03894","DSC04037","DSC04102","DSC03981","DSC03847"].map(function (f) { return ED + f + ".jpg"; });
  var IRL = ["DSC03873","DSC03891","DSC03955","DSC04034","DSC04068","DSC04078"].map(function (f) { return ED + f + ".jpg"; });

  var TRUST = ["Handmade Small Batch","Cruelty Free","No Parabens","No Sulfates","Sensitive Skin Friendly","Natural Ingredients","Secure Checkout","Free Shipping $75+"];

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var money = function (n) { return "$" + n.toFixed(2); };
  var moneyCents = function (c) { return "$" + (c / 100).toFixed(2); };
  var el = function (html) { var t = document.createElement("template"); t.innerHTML = html.trim(); return t.content.firstChild; };

  /* ---------- RENDER: products ---------- */
  function renderProducts() {
    var grid = $("#productGrid");
    if (!grid) return;
    PRODUCTS.forEach(function (p) {
      var badges = p.badges.map(function (b) {
        return '<span class="badge badge--' + b[1] + '">' + b[0] + "</span>";
      }).join("");
      var stars = "★★★★★";
      var media = '<a href="' + p.url + '" style="display:block;width:100%;height:100%;"><img src="' + p.img + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;"></a>';
      var addAttr = p.variantId
        ? 'data-variant="' + p.variantId + '" data-add="' + p.title + '"'
        : 'data-href="' + p.url + '"';
      var card = el(
        '<article class="pcard">' +
          '<div class="pcard__media">' +
            '<div class="pcard__badges">' + badges + "</div>" +
            media +
          "</div>" +
          '<div class="pcard__body">' +
            '<h3 class="pcard__title"><a href="' + p.url + '" style="color:inherit;text-decoration:none;">' + p.title + "</a></h3>" +
            '<p class="pcard__desc">' + p.desc + "</p>" +
            '<span class="stars"><span class="stars__icons">' + stars + "</span> " + p.rating.toFixed(1) + "</span>" +
            '<div class="pcard__price">' + money(p.price) + (p.compareAt ? ' <s style="color:var(--taupe-soft);font-weight:400;font-size:.72em;">' + money(p.compareAt) + '</s>' : '') + "</div>" +
            '<button class="pcard__add" ' + addAttr + '>Quick Add</button>' +
          "</div>" +
        "</article>"
      );
      grid.appendChild(card);
    });
  }

  /* ---------- RENDER: concerns ---------- */
  function renderConcerns() {
    var grid = $("#concernGrid");
    if (!grid) return;
    CONCERNS.forEach(function (c) {
      grid.appendChild(el(
        '<a class="concern" href="' + (c.url || "#concern") + '">' +
          '<img class="tile-img" src="' + c.img + '" alt="' + c.title + '" loading="lazy">' +
          '<div class="concern__body">' +
            "<h3>" + c.title + "</h3>" +
            "<p>" + c.desc + "</p>" +
            '<span class="concern__link">Shop now →</span>' +
          "</div>" +
        "</a>"
      ));
    });
  }

  /* ---------- RENDER: lookbook + irl ---------- */
  function renderGallery(id, files) {
    var box = $("#" + id);
    if (!box) return;
    files.forEach(function (src) {
      box.appendChild(el('<figure><img src="' + src + '" alt="Kaynaturalz editorial" loading="lazy"></figure>'));
    });
  }

  /* ---------- RENDER: marquee ---------- */
  function renderMarquee(id) {
    var track = $("#" + id);
    if (!track) return;
    var dot = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/></svg>';
    var items = TRUST.concat(TRUST).map(function (t) {
      return '<span class="marquee__item">' + dot + t + "</span>";
    }).join("");
    track.innerHTML = items;
  }

  /* ---------- CART — real Shopify AJAX cart ---------- */
  function openDrawer(d) { d.classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeAll() {
    $("#cartDrawer").classList.remove("open");
    $("#mobilenav").classList.remove("open");
    $("#overlay").classList.remove("open");
    document.body.style.overflow = "";
  }

  function renderCart(cart) {
    var body = $("#cartBody"), foot = $("#cartFoot"), countEl = $("#cartCount");
    var qty = cart.item_count;
    if (qty > 0) { countEl.hidden = false; countEl.textContent = qty; } else { countEl.hidden = true; }
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p><a href="/collections/inventory" class="btn btn--dark" id="cartShop">Shop the collection</a></div>';
      foot.hidden = true;
      return;
    }
    var lines = cart.items.map(function (it, idx) {
      var img = it.image
        ? '<img src="' + it.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:10px;">'
        : '<div class="ph"><span>·</span></div>';
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? " · " + it.variant_title : "";
      return '<div class="cart-line">' +
        '<div class="cart-line__img">' + img + '</div>' +
        '<div class="cart-line__info"><h4>' + it.product_title + variant + "</h4>" +
          "<span>Qty " + it.quantity + "</span>" +
          '<div class="cart-line__rm" data-rm="' + (idx + 1) + '">Remove</div></div>' +
        '<div class="cart-line__price">' + moneyCents(it.final_line_price) + "</div>" +
      "</div>";
    }).join("");
    body.innerHTML = lines;
    foot.hidden = false;
    $("#cartTotal").textContent = moneyCents(cart.items_subtotal_price);
    body.querySelectorAll("[data-rm]").forEach(function (b) {
      b.addEventListener("click", function () { changeLine(+b.dataset.rm, 0); });
    });
  }

  function refreshCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () { return refreshCart(); });
  }

  function bindAddButtons() {
    document.querySelectorAll("button[data-variant], button[data-href]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.dataset.href) { window.location.href = btn.dataset.href; return; }
        var orig = btn.textContent;
        addToCart(+btn.dataset.variant, btn).then(function () {
          if (btn.classList.contains("pcard__add")) {
            btn.classList.add("added"); btn.textContent = "Added ✓";
            setTimeout(function () { btn.classList.remove("added"); btn.textContent = orig; }, 1300);
          } else {
            openDrawer($("#cartDrawer"));
          }
        }).catch(function (e) {
          btn.textContent = (e && e.description) ? "Sold out" : "Try again";
          setTimeout(function () { btn.textContent = orig; }, 1800);
        });
      });
    });
  }

  /* ---------- ANNOUNCEMENT rotation ---------- */
  function startAnnounce() {
    var msgs = document.querySelectorAll(".announce__msg");
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-on");
    }, 3800);
  }

  /* ---------- HERO carousel ---------- */
  function startHeroDots() {
    var dots = document.querySelectorAll(".hero__dots i");
    var slides = document.querySelectorAll(".hero__slide");
    if (!dots.length || !slides.length) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 4500); }
    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { clearInterval(timer); go(k); auto(); });
    });
    go(0); auto();
  }

  /* ---------- SCROLL reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- shared cart API for other page scripts (PDP) ---------- */
  window.KNCart = {
    add: addToCart,
    refresh: refreshCart,
    open: function () { openDrawer($("#cartDrawer")); }
  };

  /* ---------- INIT ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    renderProducts();
    renderConcerns();
    renderGallery("lookbook", LOOKBOOK);
    renderGallery("irl", IRL);
    bindAddButtons();
    refreshCart();
    startAnnounce();
    startHeroDots();
    initReveal();

    $("#cartBtn").addEventListener("click", function () { openDrawer($("#cartDrawer")); });
    $("#cartClose").addEventListener("click", closeAll);
    $("#burger").addEventListener("click", function () { openDrawer($("#mobilenav")); });
    $("#mobileClose").addEventListener("click", closeAll);
    $("#overlay").addEventListener("click", closeAll);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

    document.querySelectorAll("#mobilenav a").forEach(function (a) { a.addEventListener("click", closeAll); });
  });
})();
